import React, { useContext } from "react";
import { useHistory } from "react-router";
import PostForm from "../Forms/PostForm";
import { AuthContext } from "../../auth";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  postCard: {
    padding: 20,
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
  },
  button: {
    color: theme.palette.common.white,
  },
}));

const PostCard = () => {
  const classes = useStyles();
  const history = useHistory();
  const { currentUser } = useContext(AuthContext);

  let postContent = null;

  if (currentUser) {
    postContent = <PostForm />;
  } else {
    postContent = (
      <div>
        <Grid
          container
          spacing={2}
          direction="column"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography component="div">
              <Box fontWeight="fontWeightBold">
                Ask your questions or tell us your queries.
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => history.push("/Login")}
              disableElevation
            >
              Login / Signup Here
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

  return <Paper className={classes.postCard}>{postContent}</Paper>;
};

export default PostCard;
